import { render } from "./CanvasDisplay.vue?vue&type=template&id=f5df493a&scoped=true"
import script from "./CanvasDisplay.vue?vue&type=script&lang=js"
export * from "./CanvasDisplay.vue?vue&type=script&lang=js"

import "./CanvasDisplay.vue?vue&type=style&index=0&id=f5df493a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5df493a"]])

export default __exports__